import React from "react"
import { useTheme } from '~/contexts/ThemeContext'
import { usePost } from '~/contexts/PostContext'
import { jnstyls, notBlank } from '~/utils/helpers'

import { CarouselWindow } from '~/components/carousel/carousel_window'
import { CarouselFixed} from '~/components/carousel/carousel_fixed'

import * as styles from "~/styles/blog/blog-carou.module.scss"
import * as bstyle from "~/styles/blog/blog.module.scss"


const BlogCarou = ({ blockId, index }) => {
  const { isMobile } = useTheme()
  const { post } = usePost()
  const block = post.data.blocks.find(x => x.id === blockId)
  const { settings } = block

  let carousel = settings.images.map( x => { return {image: isMobile && notBlank(x.mobile) ? x.mobile : x.desk, caption: x.caption} })
  carousel = carousel.filter(x => !!x.image)

  const carou_data = {
    carousel: carousel,
    title: false,
    copy: false,
    caption: settings.caption,
    captions: settings.captions
  }

  return (
    <>
      {settings.carou_type ? (
        <>
          <CarouselFixed carou_data={carou_data} par_styles={jnstyls([styles.story_fixed, styles.factory])} />
          <br />
        </>
      ) : (
        <>
          <br />
          <CarouselWindow carou_data={carou_data} par_styles={jnstyls([bstyle.sec, styles.carou])} />
        </>
      )}
    </>
  )
}

export default BlogCarou